import { createContext, useContext, useState, useCallback, ReactNode } from "react";
import { it } from "./translations/it";
import { en } from "./translations/en";

export type Lang = "it" | "en";
type Translations = typeof it;

const translations: Record<Lang, Translations> = { it, en: en as unknown as Translations };

interface LanguageContextType {
  lang: Lang;
  setLang: (lang: Lang) => void;
  t: Translations;
}

const LanguageContext = createContext<LanguageContextType>({
  lang: "it",
  setLang: () => {},
  t: it,
});

export const LanguageProvider = ({ children }: { children: ReactNode }) => {
  const [lang, setLangState] = useState<Lang>(() => {
    const stored = localStorage.getItem("avps-lang");
    return (stored === "en" ? "en" : "it") as Lang;
  });

  const setLang = useCallback((l: Lang) => {
    setLangState(l);
    localStorage.setItem("avps-lang", l);
  }, []);

  return (
    <LanguageContext.Provider value={{ lang, setLang, t: translations[lang] }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);
